import { render, staticRenderFns } from "./settingTable.vue?vue&type=template&id=51b47aa2&scoped=true&"
import script from "./settingTable.vue?vue&type=script&lang=js&"
export * from "./settingTable.vue?vue&type=script&lang=js&"
import style0 from "./settingTable.vue?vue&type=style&index=0&id=51b47aa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b47aa2",
  null
  
)

export default component.exports